import { createFileInput } from "Utils/file-loader/create-file-input";
import { DialogsModule } from "Utils/dialogs-module";
import "Dialogs/import-poll-dialog";
import { PollCreateEvent } from "../events/poll";
import "Dialogs/poll-folder/select-poll-folder-dialog";
import { Translator } from "@/utils/translate";
import { authenticatedPollApiFetch } from "./poll-api-request";
const pollsTranslator = Translator("polls");

async function importPollInNewConstructor(file, folderId) {
  const formData = new FormData();
  formData.append("file", file);
  if (folderId) formData.append("folderId", folderId);

  const response = await authenticatedPollApiFetch("/poll/api/v1/polls/import", {
    method: "POST",
    body: formData,
  });
  const responseData = await response.json().catch(() => null);
  const importedPoll = responseData?.data;

  if (!response.ok || !responseData?.success || !importedPoll?.id) {
    const message =
      responseData?.error?.details?.message ||
      responseData?.error?.message ||
      "При импорте опроса произошла ошибка, проверьте файл";
    const importError = new Error(message);
    importError.code = responseData?.error?.code;
    throw importError;
  }

  return importedPoll;
}

function importPoll(event) {
  event.preventDefault();

  let control = {};
  DialogsModule(control);

  let poll = ko.observable(null);
  let loading = ko.observable(true);
  let error = ko.observable(null);
  let isOldFormatError = ko.observable(false);

  const selectFile = (folderId) => {
    createFileInput(
      ({ file }) => {
        control.openDialog({
          name: "import-poll-dialog",
          params: {
            loading,
            poll,
            error,
            isOldFormatError,
          },
        });

        importPollInNewConstructor(file, folderId)
          .then((importedPoll) => {
            poll({
              name: importedPoll.name,
              link: `/foquz/lk?pollId=${importedPoll.id}`,
            });
            PollCreateEvent.emit();
          })
          .catch((importError) => {
            const isOldFormat =
              importError.code === "MISMATCH_ERROR" ||
              importError.code === "IMPORT_OLD_FORMAT";

            isOldFormatError(isOldFormat);
            error(
              isOldFormat
                ? "Формат файла устарел и не поддерживается."
                : importError.message
            );
          })
          .finally(() => {
            loading(false);
          });
      },
      { open: true, accept: "application/JSON" }
    );
  };

  if (CURRENT_USER.editor) {
    control.openDialog({
      name: "select-poll-folder-dialog",
      params: {
        title: pollsTranslator.t("Выберите папку для импорта опроса"),
        confirm: pollsTranslator.t("Импортировать опрос"),
        mode: "success",
        onSelect: (folderId) => {
          selectFile(folderId);
          return Promise.resolve();
        },
      },
    });
  } else {
    selectFile();
  }
}

$(() => {
  $(document.body).on("click", "[data-import-poll]", importPoll);
});
